// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1fpfN","range":"MonthRangeSwitch_range__TjQtS","disabled":"MonthRangeSwitch_disabled__1h5Nr"};